export const environment = {
  name: 'development',
  production: false,
  version: '0.5',
  appUrl: 'https://development-saas-prev-and-co.layxo.net',
  apiUrl: 'https://development-saas-prev-and-co.layxo.net/api',
  restrictedFeatures: {},
};
